import { NOTIFICATION } from '../../reduxs'

const initialState = {
  payload: null,
  isOpenToastNotification: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION.actionType.NOTIFICATION_DATA:
      return { ...state, payload: action.data.payload }
      
      case NOTIFICATION.actionType.TOGGLE_NOTIFICATION:
      return { ...state, isOpenToastNotification: action.data.isOpenToastNotification }

    default:
      return state   
  }
}
